<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M.854 3.646 4.647 7.44a.5.5 0 0 1 0 .708L.854 11.94A.5.5 0 0 1 0 11.586V4a.5.5 0 0 1 .854-.354Zm7.501-3.5 3.793 3.792a.5.5 0 0 1-.353.855H4.208a.5.5 0 0 1-.352-.855L7.648.146a.5.5 0 0 1 .707 0Z" fill="currentColor"/><path d="M11.796 10.791a.5.5 0 0 1 .352.856l-2.145 2.144-1.647 1.648a.5.5 0 0 1-.707 0l-3.793-3.792a.5.5 0 0 1 .353-.856h7.587Zm3.703-7.294a.5.5 0 0 1 .503.501v7.586a.5.5 0 0 1-.854.354l-3.793-3.793a.5.5 0 0 1 0-.708l3.793-3.792a.492.492 0 0 1 .351-.148Z" opacity=".45" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering04',
});
</script>
